<template>
  <div class="site_lease">
    <van-sticky>
      <van-nav-bar v-if="isPlace" title="订单详情" left-arrow @click-left="goback()" right-text="编辑" @click-right="toEdit()" />
      <van-nav-bar v-if="!isPlace" title="订单详情" left-arrow @click-left="goback()"  />
    </van-sticky>

    <CardBuilding :detailData="detailData.siteVo"></CardBuilding>

    <!-- 表单 -->
    <van-form label-width="100" class="lease_form">
      <van-cell-group>
        <van-field
          input-align="right"
          :value="detailData.orderNumber"
          label="订单号"
          placeholder="请输入"
          readonly
        />

        <van-field
          input-align="right"
          :value="detailData.paymentNumber || '线下支付订单无支付编号'"
          label="支付编号"
          placeholder="请输入"
          readonly
        />

        <van-field
          input-align="right"
          :value="detailData.payablePrice"
          label="订单价格"
          placeholder="请输入"
          readonly
        />
        
        <van-field
          input-align="right"
          :value="detailData.discountAmount"
          label="优惠价格"
          placeholder="请输入"
          readonly
        />

        <van-field
          input-align="right"
          :value="detailData.status_name"
          label="订单状态"
          placeholder="请输入"
          readonly
        />

        <van-field
          input-align="right"
          :value="detailData.paymentTime"
          label="支付时间"
          placeholder="请输入"
          readonly
        />

        <div class="lease_title">签约主体信息</div>

        <van-field
          input-align="right"
          :value="detailData.contactName"
          label="姓名"
          placeholder="请输入"
          readonly
        />

        <van-field
          input-align="right"
          :value="detailData.user_telephone"
          label="手机号"
          placeholder="请输入"
          readonly
        />

        <van-field
          input-align="right"
          :value="detailData.intermediary_company"
          label="中介公司名"
          placeholder="请输入"
          readonly
        />

        <van-field
          input-align="right"
          :value="detailData.company"
          label="预注册公司名称"
          placeholder="请输入"
          readonly
        />

        <div class="form_feature">
          <div class="fs14">场地用途</div>
          <div class="feature_list">
            <van-button
              color="#0CADFC"
              v-for="items in detailData.siteUse_name"
              :key="items"
              type="info"
              >{{ items }}</van-button
            >
          </div>
        </div>

        <div class="form_feature">
          <div class="fs14">请选择租赁时长：</div>
          <div class="feature_list">
            <van-button
              color="#0CADFC"
              v-for="items in detailData.leaseDuration_name"
              :key="items"
              type="info"
              >{{ items }}</van-button
            >
          </div>
        </div>

        <div class="lease_mark">备注:</div>

        <van-field
          class="lease_mark_area"
          :value="detailData.remark"
          rows="2"
          type="textarea"
          placeholder="请检单描述你的需求"
          show-word-limit
          autosize="{ maxHeight: 400, minHeight: 200 }"
          readonly
        />

        <div class="lease_title">补录资料信息</div>

        <div class="contract_data">
          <div class="data_idcard">
            <div>身份证<span style="color:red;font-size: 13px;">（*点击可放大预览）</span></div>
            <div class="idcard_img">
              <div class="img_item" @click="showImage(detailData.idCard_front)">
                <van-image
                  width="100%"
                  fit="fill"
                  :src="detailData.idCard_front"
                />
                <div>正面</div>
              </div>
              <div class="img_item" @click="showImage(detailData.idCard_back)">
                <van-image
                  width="100%"
                  fit="fill"
                  :src="detailData.idCard_back"
                />
                <div>反面</div>
              </div>
            </div>
          </div>

          <van-form label-width="140">
            <van-cell-group>
              <van-field
                input-align="right"
                :value="detailData.idCard"
                label="身份证号码"
                placeholder="请输入"
                is-link
                readonly
              />

              <div class="data_idcard">
                <div class="m-b20">营业执照<span style="color:red;font-size: 13px;">（*点击可放大预览）</span></div>
                <van-image @click="showImage(detailData.businessLicense)"
                  width="100%"
                  fit="fill"
                  :src="detailData.businessLicense"
                />
              </div>

              <van-field
                input-align="right"
                :value="detailData.unifiedSocialCreditCode"
                label="统一社会信用代码"
                placeholder="请输入"
                is-link
                readonly
              />

              <van-field
                input-align="right"
                :value="detailData.company_official"
                label="公司名称"
                placeholder="请输入"
                is-link
                readonly
              />

              <van-field
                input-align="right"
                :value="detailData.company_legalPerson"
                label="法人姓名"
                placeholder="请输入"
                is-link
                readonly
              />

              <van-field
                input-align="right"
                :value="detailData.company_address"
                label="地址"
                placeholder="请输入"
                is-link
                readonly
              />

              <div class="data_idcard">
                <div class="m-b20">合同文件</div>

                <van-swipe
                  class="my-swipe"
                  :autoplay="1000"
                  indicator-color="black"
                >
                  <van-swipe-item>
                    <van-image
                      v-for="items in detailData.contractImageList"
                      :key="items"
                      width="100%"
                      fit="fill"
                      :src="items.url"
                  /></van-swipe-item>
                </van-swipe>
              </div>

              <van-field
                input-align="right"
                :value="detailData.contractSignTime"
                label="签约日期"
                placeholder="请输入"
                is-link
                readonly
              />

              <van-field
                input-align="right"
                :value="detailData.contractExpirationTime"
                label="到期日期"
                placeholder="请输入"
                is-link
                readonly
              />
            </van-cell-group>
          </van-form>
        </div>
      </van-cell-group>
    </van-form>

    <div @click="isShowImage = false" v-if="isShowImage" style="position:fixed;top:0px;left:0px;width: 100%;height: 100%;background: rgba(0,0,0,0.5);z-index:10">
        <van-image
        @click="isShowImage = false"
          width="100%"
          :src="targetImage"
          height="100%"
          fit="scale-down"
        />
    </div>
  </div>
</template>

<script>
import CardBuilding from "../home/components/CardBuilding";
import {
  Button,
  NavBar,
  Icon,
  Sticky,
  Image,
  Form,
  Field,
  CellGroup,
  RadioGroup,
  Radio,
  Tag,
  Swipe,
  SwipeItem,
} from "vant";

export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Tag.name]: Tag,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    CardBuilding,
  },
  data() {
    return {
      orderId:0,
      isShowImage: false,
      targetImage:'',
      detailData: [],
    };
  },

  created() {
    this.orderId = this.$route.query.id
    this.isPlace = this.$route.query.isPlace ? true:false;
    //订单-查看
    this.orderInfoDetail(this.$route.query.id);
  },

  methods: {

    showImage(targetUrl){
      this.isShowImage = true
      this.targetImage = targetUrl
    },

    //订单-查看
    orderInfoDetail(id) {
      var that = this;
      that.$api
        .orderInfoDetailAPI({ id: id })
        .then(function (res) {
          if (res.data.code === 200) {
            res.data.data.siteUse_name = res.data.data.siteUse_name.split(",");
            res.data.data.leaseDuration_name =
              res.data.data.leaseDuration_name.split(",");
            that.detailData = res.data.data;
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    onsubmit() {
      this.$router.go(-1);
    },

    //编辑页面
    toEdit(){
      this.$router.push({ path: "/order/OrderEdit" , query: { id: this.orderId }});
    }
  },
};
</script>

<style lang="less" scoped>
.site_lease {
  .form_feature {
    color: #646566;
    margin: 15px 10px;

    .feature_list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .van-button {
        height: 35px;
        margin-top: 15px;
        width: 100px;
        margin-right: 15px;
      }
    }

    .feature_server {
      display: flex;
      justify-content: space-between;
      font-size: 15px;
      margin-top: 15px;
      align-items: center;

      .server_btn {
        display: flex;
        justify-content: space-between;

        .van-button {
          width: 100px;
          margin-left: 15px;
        }
      }
    }
  }

  .lease_title {
    font-size: 14px;
    color: #666;
    padding: 15px 20px;
    background: #f4f3f8;
  }

  .lease_mark {
    font-size: 14px;
    color: #666;
    padding: 0px 20px;
    background: #fff;
  }

  .van-radio-group {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .van-button {
    height: 35px;
  }

  .lease_mark_area /deep/.van-field__value {
    height: 100px;
    background: #f4f3f8;
    padding: 10px;
    font-size: 16px;
  }

  .contract_data {
    .data_idcard {
      padding: 25px 16px;
      color: #323233;
      font-size: 15px;

      .idcard_img {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 10px;

        .img_item {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          width: 48%;
        }

        .img_license {
          border-radius: 2px;
          background-color: rgba(0, 0, 0, 0.02);
          width: 100%;
          border: 1px solid rgba(0, 0, 0, 0.15);
          height: 150px;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
        }
      }
    }
  }

  /deep/ .van-field__control {
    color: #979797;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/order/orderDetail.vue